import { AuthorizedAxios, throwErrorResponse } from 'src/common/services/axios';
import { flatten } from 'src/lib/axios';
import {
  CourseMaterialFileDTO,
  CourseMaterialsDTO,
  MaterialResourceObjectDTO,
  DownloadCourseMaterialDTO,
  UserCourseMaterialsCriteria,
} from 'src/common/models/courseMaterial';
import { GetInfiniteQueryFunctionContext, PageResultDTO } from 'src/common/models/page';
import { userCourseMaterialsPageSize } from 'src/config/user';
import { forceDownload } from 'src/common/services/file';
import { ListWrapper, unwrap } from 'src/lib/listWrapper';

export const downloadCourseMaterial = async (list: CourseMaterialFileDTO[]) =>
  Promise.allSettled(
    list.map((dto) =>
      AuthorizedAxios.get<DownloadCourseMaterialDTO>(`/api/materials/${dto.id}/download`)
        .then(flatten)
        .then((downloadUrl) => {
          forceDownload(downloadUrl.url);
        })
        .catch(throwErrorResponse),
    ),
  );

export const getUserCourseMaterials = (
  { pageParam, pageSize }: GetInfiniteQueryFunctionContext,
  { resourceId, materialResource }: UserCourseMaterialsCriteria,
) =>
  AuthorizedAxios.get<PageResultDTO<CourseMaterialsDTO>>('/api/materials/me', {
    params: {
      resourceId,
      materialResource,
      pageSize: pageSize ?? userCourseMaterialsPageSize,
      page: pageParam || 1,
    },
  })
    .then(flatten)
    .catch(throwErrorResponse);

export const getUserCourseMaterialsTitles = () =>
  AuthorizedAxios.get<ListWrapper<MaterialResourceObjectDTO>>('/api/materials/course/title/me')
    .then(flatten)
    .then(unwrap)
    .catch(throwErrorResponse);
